import * as S from "./Header.style";
import { Buttons } from "@/components/atoms/Buttons";
import { ReactComponent as IconHamburger } from "@/styles/assets/svg/icon_hamburger.svg";
import { ReactComponent as IconHamburgerActive } from "@/styles/assets/svg/icon_hamburger_active.svg";
import { ReactComponent as IconCalender } from "@/styles/assets/svg/icon_calender.svg";

interface HeaderProps {
  buttonLeft?: React.ReactElement;
  buttonMenu?: boolean;
  calenderBtn?: Boolean;
  headerTitle?: string;
  buttonRight?: React.ReactElement;
  handleMenuOpen?: any;
  isAlarm?: boolean;
  onCalendarClick?: () => void;
}

export const Header = ({
  buttonLeft,
  buttonMenu,
  calenderBtn,
  headerTitle,
  buttonRight,
  handleMenuOpen,
  isAlarm,
  onCalendarClick,
}: HeaderProps) => {
  return (
    <S.Header>
      <S.HeaderLeft>{buttonLeft && buttonLeft}</S.HeaderLeft>

      <S.HeaderTitle>{headerTitle}</S.HeaderTitle>

      <S.HeaderRight>
        {calenderBtn && (
          <Buttons
            type="button"
            size="headerIcon"
            layout="text"
            color="bright100"
            icon={<IconCalender width={22} height={22} />}
            onClick={onCalendarClick}
          />
        )}
        {buttonMenu && (
          <Buttons
            type="button"
            size="headerIcon"
            layout="text"
            color="bright100"
            icon={isAlarm ? <IconHamburgerActive /> : <IconHamburger />}
            onClick={handleMenuOpen}
          />
        )}
        {buttonRight && buttonRight}
      </S.HeaderRight>
    </S.Header>
  );
};
